import { resolveActorLabel, type AuditEntry } from "@/types/audit-log.types";
import { resolveAuditResourceLabel, resolveResourceTypeLabel } from "@/features/audit-log/utils/audit-display";

type TFn = (key: string, values?: Record<string, string | number | Date>) => string;

function safeT(t: TFn, key: string, values?: Record<string, string | number | Date>) {
  try {
    const rendered = t(key, values);
    return rendered === key ? null : rendered;
  } catch {
    return null;
  }
}

function humanizeAction(actionKey: string) {
  return actionKey.replace(/[._-]+/g, " ");
}

export function renderResourceAuditEntry(entry: AuditEntry, t: TFn): string {
  const actor = resolveActorLabel(entry.actor, safeT(t, "audit.actor_unknown") ?? "Unknown");
  const resource = resolveAuditResourceLabel(entry, t)
    || (entry.resourceType ? resolveResourceTypeLabel(entry.resourceType, t) : "");
  const action = humanizeAction(entry.actionKey || entry.action || "");

  return safeT(t, "resource_activity.audit.safe_summary", {
    actor,
    action,
    resource,
  }) ?? [actor, action, resource].filter(Boolean).join(" · ");
}
